var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProtected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "55px",
    viewBox: "0 0 51 55",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Compra-protegida") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-1015.000000, -5374.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(0.000000, 5295.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compra-protegida",
    transform: "translate(1016.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8786797,32.8786797 L16.2928932,27.2928932 L16.2928932,27.2928932 C15.9023689,26.9023689 15.9023689,26.2692039 16.2928932,25.8786797 L17.8786797,24.2928932 L17.8786797,24.2928932 C18.2692039,23.9023689 18.9023689,23.9023689 19.2928932,24.2928932 L22.5857864,27.5857864 L31.8786797,18.2928932 L31.8786797,18.2928932 C32.2692039,17.9023689 32.9023689,17.9023689 33.2928932,18.2928932 L34.8786797,19.8786797 L34.8786797,19.8786797 C35.2692039,20.2692039 35.2692039,20.9023689 34.8786797,21.2928932 L23.2928932,32.8786797 L23.2928932,32.8786797 C22.9023689,33.2692039 22.2692039,33.2692039 21.8786797,32.8786797 Z",
    id: "Shape",
    fill: "#3483FA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7086777,0.4124 C24.7086777,0.4124 17.7086777,10.4124 0.708677686,7.4124 C0.708677686,7.4124 -5.29132231,36.7674 24.7086777,52.5904 C54.7086777,36.7674 48.7086777,7.4124 48.7086777,7.4124 C31.7086777,10.4124 24.7086777,0.4124 24.7086777,0.4124 Z",
    id: "Page-1",
    stroke: "#474747",
    strokeWidth: 1.413,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtected);
export default __webpack_public_path__ + "static/media/protected.0d3e79f277c716ab4c80b04cc1ff66f6.svg";
export { ForwardRef as ReactComponent };